import styled from '@emotion/styled';

import Switch from '../../../styledComponents/UI/Switch/Switch';

export const StyledSwitch = styled(Switch)`
  margin-top: 2.25rem;
`;
